import React, { createContext, useContext, useState } from "react";

const SchoolDetailsContext = createContext({
  schoolDetailsData: [],
  setSchoolDetailsData: () => null,
});

export const useSchoolDetailsContext = () => useContext(SchoolDetailsContext);

export const SchoolDetailsProvider = ({ children }) => {
  const [schoolDetailsData, setSchoolDetailsData] = useState([]);

  return (
    <SchoolDetailsContext.Provider
      value={{ schoolDetailsData, setSchoolDetailsData }}
    >
      {children}
    </SchoolDetailsContext.Provider>
  );
};
